import React, { Fragment } from "react";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import {
  Col,
  Card,
  CardBody,
  CardTitle,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Row,
} from "reactstrap";
import { ResponsiveContainer, LineChart, Line } from "recharts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";

import TablaAulas from "./AlumnosList";
import privateActions from "../../../../../API/privateCalls/privateActions";
export default class Planetas extends React.Component {
  state = {   loading: true,
    data: {},
    pagePlaneta: 0,
    sizePlaneta: 7,
    pageAlumnos: 0,
    sizeAlumnos: 10,
    pageActividades: 0,
    sizeActividades: 10,
    listPlanetas: [],
    listaTabs: [],
    selectedAlumno:{},
    selectedTabKey: 0,
    selectedAula: {},
    listAlumnosAulasActive: [],
    selectedActivity: "",
    activityResponse: [],tiempoPromedio:0};

  componentDidMount() {
    this.LoadPlaneta()
  }



  //////////////////////////////CORDON START


  LoadPlaneta() {
    privateActions.sharedPlanetas(
        this.state.pagePlaneta,
        this.state.sizePlaneta
      )
      .then((res) => {
        console.log("RES", res);
        this.setState({ listPlanetas: res, loading: false });
      });
  }

  paginateAulas(direc) {
    if (direc > 0) {
      this.setState({ pagePlaneta: this.state.pagePlaneta + 1 }, () => {
        this.LoadPlaneta();
      });
    } else {
      this.setState(
        {
          pagePlaneta:
            this.state.pagePlaneta == 0
              ? this.state.pagePlaneta
              : this.state.pagePlaneta - 1,
        },
        () => {
          this.LoadPlaneta();
        }
      );
    }
  }




  ///////////////////////////////CORDON END


  render() {
    if (this.state.loading ) return null;
    return (
      <Fragment>
        <ReactCSSTransitionGroup
          component="div"
          transitionName="TabsAnimation"
          transitionAppear={true}
          transitionAppearTimeout={0}
          transitionEnter={false}
          transitionLeave={false}
        >
      
          <Row>
            <Col lg="12">
              <Card className="main-card mb-3">
                <CardBody>
                  <CardTitle>Planetas</CardTitle>
                  <TablaAulas
                    page={this.state.pagePlaneta}
                    paginate={(num) => this.paginateAulas(num)}
                    data={this.state.listPlanetas}
                    onViewAula={(data) => this.handleSelectAula(data)}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </ReactCSSTransitionGroup>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// src/Pages/ObjetivosDelJuego/elementosDelJuego/Planetas-admin/component/Planetas.js